import { useEffect, useState, useRef } from 'react';
import styles from './HotModal.module.css';


const HotModal = ({setIsHotModalShown, isAdmin, setActiveMenu, setInfoModalPage, marginTop}) => {
	const [visible, setVisible] = useState(false);
	const videoRef = useRef(null);

	const resumeVideo = () => {
		// 알럿 후 재생 재시도
		videoRef.current?.play().catch(() => {/* 무시 */});
		setTimeout(() => {
			videoRef.current?.play().catch(() => {/* 무시 */});
		}, 100);
	};
	
	const tickMs = 1500; // 전환 간격
	const animMs = 800;  // 페이드/텍스트 전환 시간

	const phrases = [
		"#주변 핫플은 어디?",
		"#오늘 뭐 먹지?",
		"#주말에 어디 가지?",
		"#데이트 때 뭐하지?"
	];
	const [idx, setIdx] = useState(0);
	const [phase, setPhase] = useState("idle");
	const [nextIdx, setNextIdx] = useState(1);

	const bgList = ['images/back_1.jpg', 'images/back_2.jpg', 'images/back_3.jpg', 'images/back_4.jpg'];
	const [showA, setShowA] = useState(true);
	const [bgIndex, setBgIndex] = useState(0);
	const [bgA, setBgA] = useState(bgList[0]);
	const [bgB, setBgB] = useState(bgList[1]);

	// refs to avoid stale closure inside setInterval
	const idxRef = useRef(idx);
	const bgIndexRef = useRef(bgIndex);
	const showARef = useRef(showA);

	// visible 애니메이션 시작
	useEffect(() => {
		setVisible(true);
	}, []);

	// 배경 + 문구 전환을 하나의 타이머로 동기화
	useEffect(() => {
		// (선택) 이미지 프리로드
		bgList.forEach(src => { const img = new Image(); img.src = src; });

		const interval = setInterval(() => {
		// 다음 인덱스 계산
		const nextPhraseIdx = (idxRef.current + 1) % phrases.length;
		const nextBgIdx = (bgIndexRef.current + 1) % bgList.length;

		// 텍스트 전환 시작
		setNextIdx(nextPhraseIdx);
		setPhase('transition');

		// 숨겨진 배경 레이어에 다음 이미지를 미리 세팅
		if (showARef.current) {
			setBgB(bgList[nextBgIdx]);
		} else {
			setBgA(bgList[nextBgIdx]);
		}

		// 배경 레이어 토글 → animMs 동안 페이드
		setShowA(prev => {
			const toggled = !prev;
			showARef.current = toggled;
			return toggled;
		});

		// animMs 후 실제 인덱스 커밋 및 idle 복귀
		setTimeout(() => {
			setIdx(prev => {
			const committed = (prev + 1) % phrases.length;
			idxRef.current = committed;
			return committed;
			});
			setPhase('idle');

			setBgIndex(() => {
			bgIndexRef.current = nextBgIdx;
			return nextBgIdx;
			});
		}, animMs);
		}, tickMs);

		return () => clearInterval(interval);
	}, []);

	const whenAIHotpleRecommendButtonClicked = (event) => {
		event.stopPropagation();
		alert(`이 기능은 베타 테스트 종료 후 제공될 예정입니다!`);
		resumeVideo();
	};

	const whenHotpleStoryButtonClicked = (event) => {
		event.stopPropagation();
		alert(`이 기능은 베타 테스트 종료 후 제공될 예정입니다!`);
	};

	const whenAdminModeButtonCliceked = () => {
		setActiveMenu('admin');
		setIsHotModalShown(false);
	};

	const whenAdViseButtonClicked = () => {
		window.location.href = `/advise${marginTop != 0 ? `?marginTop=${marginTop}` : ''}`;
		setIsHotModalShown(false);
	};

	useEffect(() => {
		setVisible(true);
		const onFocus = () => resumeVideo();
		window.addEventListener('focus', onFocus);
		return () => window.removeEventListener('focus', onFocus);
	}, []);

  	return (
		<div className={`${styles.modalbackground} ${visible ? styles.visible : ''}`} onClick={()=>setIsHotModalShown(false)}>
			<div className={`${styles.modalcontainer} ${visible ? styles.visible : ''}`} onClick={(event)=>event.stopPropagation()}>
				<div className={styles.contentsframe}>
					{isAdmin &&
						<>
							<div className={styles.captionframe2}>
								<div className={styles.div3}>❗ 관리자 전용 메뉴 ❗</div>
							</div>
							<div className={styles.funcButtons2}>
								<div className={styles.recommendbutton} onClick={whenAdminModeButtonCliceked}>
									<div className={styles.background} />
									<img className={styles.iconmyLocation} alt="" src="images/setting.svg" />
									<div className={styles.text}>
										<b className={styles.ai}>관리자 모드</b>
										<div className={styles.div1}>
											<p className={styles.p}>핫플 관리 / 유저 관리</p>
											<p className={styles.p}>팝업 관리 / 배너 관리</p>
										</div>
									</div>
								</div>
								<div className={styles.recommendbutton} onClick={whenAdViseButtonClicked}>
									<div className={styles.background} />
									<img className={styles.iconfire} alt="" src="images/pen.svg" />
									<div className={styles.text}>
										<b className={styles.ai}>AdVise.ai</b>
										<div className={styles.div1}>
											<p className={styles.p}>HOTPLE 인스타 업로드용</p>
											<p className={styles.p}>광고 콘텐츠 제작 시스템</p>
										</div>
									</div>
								</div>
							</div>
						</>
					}
					<div className={styles.captionframe}>
							<div className={styles.div3}>AI를 활용한 다양한 기능들을 준비 중이에요 ☺️</div>
					</div>
					<div className={styles.funcButtons}>
						<div className={styles.recommendbutton} onClick={whenAIHotpleRecommendButtonClicked}>
							<div className={styles.bgBase} />
							<div
								className={`${styles.bg} ${showA ? styles.visible : styles.hidden}`}
								style={{ backgroundImage: `url(${bgA})` }}
							/>
							<div
								className={`${styles.bg} ${showA ? styles.hidden : styles.visible}`}
								style={{ backgroundImage: `url(${bgB})` }}
							/>
							<div className={styles.text}>
								<div className={`${styles.ticker} ${phase === "transition" ? styles.transition : ""}`}>
									<b className={`${styles.ai} ${styles.line} ${phase === "transition" ? styles.exit : ""}`}>
										{phrases[idx]}
									</b>
									{phase === "transition" && (
										<b className={`${styles.ai} ${styles.line} ${styles.enter}`}>
										{phrases[nextIdx]}
										</b>
									)}
								</div>
								<div className={styles.div1}>
									<p className={styles.p}>어디갈지 고민될 때</p>
									<p className={styles.p}>SNS 콘텐츠로 장소 고르기</p>
								</div>
							</div>
							<div className={styles.recommendbuttonChild} />
							<div className={styles.iconlockGroup}>
								<img className={styles.iconlock} alt="" src="images/lock.svg" />
								<div className={styles.div2}>업데이트 예정!</div>
							</div>
						</div>
						{/*<div className={styles.recommendbutton} onClick={whenAIHotpleRecommendButtonClicked}>
							<div className={styles.background} />
							<img className={styles.iconmyLocation} alt="" src="images/my_location.svg" />
							<div className={styles.text}>
								<div className={`${styles.ticker} ${phase === "transition" ? styles.transition : ""}`}>
									<b className={`${styles.ai} ${styles.line} ${phase === "transition" ? styles.exit : ""}`}>
										{phrases[idx]}
									</b>
									{phase === "transition" && (
										<b className={`${styles.ai} ${styles.line} ${styles.enter}`}>
										{phrases[nextIdx]}
										</b>
									)}
								</div>
								<div className={styles.div1}>
									<p className={styles.p}>어디갈지 고민될 때</p>
									<p className={styles.p}>SNS 콘텐츠로 장소 고르기</p>
								</div>
							</div>
							<div className={styles.recommendbuttonChild} />
							<div className={styles.iconlockGroup}>
								<img className={styles.iconlock} alt="" src="images/lock.svg" />
								<div className={styles.div2}>업데이트 예정!</div>
							</div>
						</div>*/}
						<div className={styles.recommendbutton} onClick={whenHotpleStoryButtonClicked}>
							<video className={styles.background1} ref={videoRef} autoPlay loop muted playsInline src="videos/back_video.mp4" onPause={() => resumeVideo()}/>
							<div className={styles.text}>
								<b className={styles.ai}>#핫플 여행 AI</b>
								<div className={styles.div1}>
									<p className={styles.p}>여행은 가고 싶은데...</p>
									<p className={styles.p}>여행계획은 누가 짜?</p>
								</div>
							</div>
							<div className={styles.recommendbuttonChild} />
							<div className={styles.iconlockGroup}>
								<img className={styles.iconlock} alt="" src="images/lock.svg" />
								<div className={styles.div2}>업데이트 예정!</div>
							</div>
							{/* <div className={styles.hotBadge}>10HP ~ 10,000HP</div> */}
						</div>
					</div>
					<div className={styles.funcButtonParent}>
						<div className={styles.funcButtons3}>
							<div className={styles.recommendbutton2} onClick={()=>{setIsHotModalShown(false); setInfoModalPage(61);}}>
								<div className={styles.background2} />
								<img className={styles.iconinstagram} alt="" src="images/instagram.svg" />
								<div className={styles.text2}>
									<b className={styles.ai}>#인스타 장소 AI 스크랩</b>
									<div className={styles.div1}>
										<p className={styles.p}>인스타 하다 발견한 장소를 나만의 HOTPLE 지도에 저장!</p>
									</div>
								</div>
							</div>
							{/* <div style={{position:'relative'}}>
								<img className={styles.bannerNotice} alt="" src="https://hotple.s3.ap-northeast-2.amazonaws.com/usage/region_instagram_follow_event_banner.png" onClick={()=>{setIsHotModalShown(false);setInfoModalPage(31);}}/>
								<div className={styles.hotBadge2}>+1,000HP</div>
							</div> */}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
};

export default HotModal;